export { C2C, ConfigurationC2C } from './c2c';
export * as C2CRestAPI from './rest-api';

export {
    C2C_REST_API_PROD_URL,
    ConnectorClientError,
    RequiredError,
    UnauthorizedError,
    ForbiddenError,
    TooManyRequestsError,
    RateLimitBanError,
    ServerError,
    NetworkError,
    NotFoundError,
    BadRequestError,
} from '@binance/common';
